import cn from 'classnames'
import React from 'react'
import { useLocalization } from '../src/hooks/useLocaleFormatter'
import { ProductUnit, ProductVariantFragment } from '../src/model/fragments'
import { getLocale } from '../src/model/locale'
import { useIsVatPreferred } from '../src/utils/useIsVatPreferred'
import { ProductVariant } from './ProductVariant'
import { useTranslate } from '../src/hooks/useTranslate'

export interface ProductVariantPickerExpandedProps {
	items: ProductVariantFragment[],
	selectedId?: null | string,
	highlight?: boolean,
	unit?: ProductUnit,
	onChange?: (id: string | null) => void
}

export const ProductVariantPickerExpanded: React.FunctionComponent<ProductVariantPickerExpandedProps> =
	({
		items,
		selectedId = null,
		highlight = false,
		unit,
		onChange,
	}) => {
		const localization = useLocalization()
		const [isVatPreferred] = useIsVatPreferred()
		const translate = useTranslate();

		const getTitle = React.useCallback((variant : ProductVariantFragment) => {
			return getLocale(variant.color?.locales, localization.possibleLocales)?.name ?? getLocale(variant.surface?.locales, localization.possibleLocales)?.name;
		}, [localization]);

		const getDescription = React.useCallback((variant : ProductVariantFragment) => {
			return variant.color ? getLocale(variant.surface?.locales, localization.possibleLocales)?.name : '';
		}, [localization]);

		if (items.length === 0) {
			return (
				<div className="productVariantPicker-none">
					<ProductVariant name="Bez variant" />
				</div>
			)
		}

		const selected =
			(selectedId !== null && items.find((item) => item.id === selectedId)) ||
			null

		const isSingle = items.length == 1
		return (
			<div className={cn('productVariantPickerExpanded', highlight && 'is-highlight', isSingle && 'is-single')}>
				{items.map((item) => 
				{
					return (
						<button
							type="button"
							className={cn("productVariantPickerExpanded-option", selected && selectedId == item.id && 'productVariantPickerExpanded-option-selected')}
							key={item.id}
							onClick={() => {
								if (onChange) {
									onChange((selected && item.id == selected.id) ? null : item.id!)
								}
							}}
						>
							<ProductVariant
								wide={true}
								name={getTitle(item)}
								description={getDescription(item)}
								prices={localization.formatPricesArray(localization.extractPrices(item.prices), 1, isVatPreferred)}
								suffix={isVatPreferred ? translate('inclVAT') : translate('noVAT')}
								unit={unit}
								image={item.sampler?.image}
							/>
						</button>
					)}
				)}
			</div>
		)
	}
